// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7000/api';

export const API_ENDPOINTS = {
  // User endpoints
  USERS: `${API_BASE_URL}/users`,
  LOGIN: `${API_BASE_URL}/users/login`,
  REGISTER: `${API_BASE_URL}/users/register`,
  REGISTER_SEND_OTP: `${API_BASE_URL}/users/register/send-otp`,
  REGISTER_VERIFY_OTP: `${API_BASE_URL}/users/register/verify-otp`,
  ME: `${API_BASE_URL}/users/me`,
  COMPLETE_SETUP: `${API_BASE_URL}/users/complete-setup`,

  // Car endpoints
  CARS: `${API_BASE_URL}/cars`,
  CARS_ALL: `${API_BASE_URL}/cars/all`,

  // Booking endpoints
  BOOKINGS: `${API_BASE_URL}/bookings`,

  // Journey endpoints
  JOURNEYS: `${API_BASE_URL}/journeys`,

  // Organization endpoints
  ORGANIZATIONS: `${API_BASE_URL}/organizations`,
  ORGANIZATION_DASHBOARD: `${API_BASE_URL}/organizations/dashboard`,

  // Driver endpoints
  DRIVERS: `${API_BASE_URL}/drivers`,

  // Maintenance endpoints
  MAINTENANCE: `${API_BASE_URL}/maintenance`,
};
